// ArChat — permisos de notificación del navegador (Push / Notification API)
// Created: 2026-03-25

/**
 * Solicita permiso de notificaciones si aún está en "default".
 * @returns {Promise<'granted'|'denied'|'default'|'unsupported'>}
 */
export async function requestNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'unsupported';
  }
  const current = Notification.permission;
  if (current === 'granted' || current === 'denied') {
    return current;
  }
  try {
    const next = await Notification.requestPermission();
    return next === 'granted' ? 'granted' : next === 'denied' ? 'denied' : 'default';
  } catch (_) {
    return 'default';
  }
}

/**
 * Estado actual sin solicitar (útil antes de subscribe push).
 * @returns {'granted'|'denied'|'default'|'unsupported'}
 */
export function getNotificationPermissionState() {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'unsupported';
  }
  const p = Notification.permission;
  if (p === 'granted' || p === 'denied') return p;
  return 'default';
}
